import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "featured-category",
  label: "Featured Category",
  description: "Display products from a specific category on the home page.",
  supportedPages: ["home", "product", "cart"],
  variants: [{ id: "v1", label: "V1 (Product Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "rows", label: "Number of Rows", type: "number", default: 1 },
    { key: "viewAllText", label: "View All Button Text", type: "string", default: "View All" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1",
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...SECTION_STYLE_FIELDS,
  ],
};
